import styled, { css } from "styled-components";

import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { ContextConsumer } from "../App";
import { PAnewUser } from "./PASideBar";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import { CssCounter } from './uikit2';

import Tap from "react-interactions";
import "react-interactions/dist/main.css";

import PAtopMenu from "./menu/PAtopMenu";
import { countMenu } from "./menu/PAtopMenu";
import { PAprojectPath } from './dashboard/PAprojectOverview';

export const PATopBar = withRouter(props => PATopB({ ...props }));


function PATopB({ wave = true, menu = false, history, match, location, ...props }) {
  useEffect(() => {
    if (location.pathname !== "/solutions" && state.menu) {
      setState({
        menu: false
      });
    }
  });

  console.log("props = ", props);
  const [state, setState] = useState({
    menu: menu,
    mishatheme: false,
    menuType: "journeys", //'journeys'
    selected: ["/game_store"]
  });
  console.log("path = ", location.pathname);
  return (
    <CSStopBar0>


        <CSSdashBg/>


      <CSStopBar
        // className="sidebar-products"
        style={{

        }}
      >
        <Link to="/dashboard/team">
        {/* <PAprojectPath> */}
          <PAlogoBe/>
        {/* </PAprojectPath> */}
        </Link>

        <div
          style={{
            display: "flex",
            flexGrow: 1,
            alignItems: "stretch",
            justifyContent: "center"
          }}
        >


        {/* <Link
          to="/install"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              active={location.pathname.indexOf('install') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "upgrade" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "install" ? true : false}  style={{color: 'white'}}>
                Level up
              </H44>
            </CssSolutionsLi>
          </Link> */}


          <Link
            to="/dashboard/all"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              active={location.pathname.indexOf('dashboard') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "dashboard" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "dashboard" ? true : false} style={{color: 'white'}}>
                Project status
              </H44>
            </CssSolutionsLi>
          </Link>






          <Link
            to="/stats/all"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              // style={{padding: '8px 16px 8px 24px',}}
              active={location.pathname.indexOf('/stats') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "stats" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "stats" ? true : false} style={{color: 'white'}}>
              <div className="l_flex">
                Analytics
                </div>
              </H44>
            </CssSolutionsLi>
          </Link>


          <Link
            to="/transactions/registry"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              style={{
                padding: '8px 16px 8px 24px',
              }}
              active={location.pathname.indexOf('/transactions/registry') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "transaction" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "transaction" ? true : false} style={{color: 'white'}}>
              <div className="l_flex">
                Transactions
                <div className="pa_prj_counter">
                <div>1,452</div>
                </div>
                </div>
              </H44>
            </CssSolutionsLi>
          </Link>


          <Link
            to="/documents/agreements"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              style={{
                padding: '8px 16px 8px 24px',
              }}
              active={location.pathname.indexOf('/documents/refunds') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "documents" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "documents" ? true : false} style={{color: 'white'}}>
              <div className="l_flex">
                Documents
                &nbsp;&nbsp;<StatusDot status="testing"/>
                {/* <div className="pa_prj_counter pa_prj_counter--warning">
                <div>!</div>
                </div> */}
                </div>
              </H44>
            </CssSolutionsLi>
          </Link>




          <Link
            to="/developers"
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
          >
            <CssSolutionsLi
              // className="pa_prj_topmenu_li"
              style={{
                padding: '8px 16px 8px 24px',
              }}
              active={location.pathname.indexOf('/developers') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: true,
                  active: "developers" //'solutions', 'webhooks', 'agreement'
                });
              }}
            >
              <H44 active={state.active === "developers" ? true : false} style={{color: 'white'}}
              className="l_flex"
              >

                <div>API Reference</div>
                <div className="pa_prj_invitedev">
                  <div className="pa_prj_icon">
                    <div>person_add</div>
                  </div>
                  <div className="pa_prj_clone0">
                    <div className="pa_prj_clone pa_prj_clone--invite">
                      <div className="pa_prj_clonebut">
                        <div className="pa_prj_icon">
                          <div>email</div>
                        </div>
                      </div>
                      <div>Invite&nbsp;developer</div>
                    </div>
                  </div>
                </div>

              </H44>
            </CssSolutionsLi>
          </Link>



          {/* <Link
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
            to="/support/subscribers"
          >
            <CssSolutionsLi
              active={location.pathname.indexOf('support') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: false,
                  active: "support" //'solutions', 'webhooks', 'license'
                });
              }}
            >
              <H44 active={state.active === "support" ? true : false}  style={{color: 'white'}}>
                Users&Customers
              </H44>
            </CssSolutionsLi>
          </Link> */}






          {/* <div className="sidebar-products__item sidebar-products__item--misha">
          <H44 active={state.active === 'webhooks' ? true : false}>Set up Webhooks</H44>
        </div> */}

          {/* <CssSolutionsLi
        // className="sidebar-products__item sidebar-products__item--misha"
        >
          <H44 active={state.active === 'agreement' ? true : false}>Sign Licensing Agreement</H44>
        </CssSolutionsLi> */}


        {/* </div> */}



        {/* <div
          style={{
            display: "flex",
            flexGrow: 1,
            alignItems: "stretch",
            justifyContent: "flex-end"
          }}
        > */}


          {/* <Link
            style={{
              display: "grid",
              placeContent: "stretch stretch"
            }}
            to="/accounting"
          >
            <CssSolutionsLi
              active={location.pathname.indexOf('accounting') !== -1 ? true : false}
              // className="sidebar-products__item sidebar-products__item--misha"
              onClick={() => {
                setState({
                  menu: false,
                  active: "accounting" //'solutions', 'webhooks', 'license'
                });
              }}
            >
              <H44 active={state.active === "products" ? true : false} style={{color: 'white'}}>
                <span>Accounting</span>
              </H44>
              <CssCounter appearance="warning">!</CssCounter>
            </CssSolutionsLi>
          </Link> */}


        </div>


        <PAnewUser />
      </CSStopBar>



      {/* <MenuCont
        menu={state.menu}
        hide={state.menu}
        style={
          {
            // minHeight: state.menu ? `600px` : `auto`
          }
        }
      >
        <MenuUl count={3}>
          <PAtopMenu
            renderProducts={["store", "subscriptions", "currency"]}
            pathname={props.location.pathname}
          />
        </MenuUl>
      </MenuCont> */}

      <CssTopShade />
    </CSStopBar0>
  );
}

export default PATopBar;



const CSSdashBg = styled.div`
  position: absolute;
  width: 100%;
  justify-content: stretch;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 480px;
  background: #011627;
  z-index: 0;
`;



const CSStopBar0 = styled.div`
color: white;
/* position: relative; */
/* z-index: 10; */
  margin: 0 48px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;

const CSStopBar = styled.div`
position: relative;
z-index: 10;
  display: flex;
  justify-content: space-between;
  /* display: "grid", */
  /* minHeight: "100px", */
  align-items: stretch;
  grid-template-columns: repeat(3, 1fr);
  /* gridColumnGap: "4%", */
  place-content: top left;
  /* border-bottom: 1px solid #c5d0db; */
  margin: 0 0 24px 0;
`;


const CssTopShade = styled.div`
  width: 100%;
  margin: 0 auto;
  position: absolute;
  background-color: #011627;
  /* background-color: #D6E0E7; */
  left: 0;
  top: 0;
  height: 400px;
  right: 0;
  z-index: -1;
`;

const CssSolutionsLi = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  transition: background-color 0.15s ease-in-out, color 0.15s ease-in-out;
  &:hover {
    background-color: rgba(0, 118, 255, 0.3);
    color: #0076ff;
  }
  ${({active})=> active && css`
    background-color: rgba(0, 118, 255, 0.08);
    color: #0076ff;
  `}
`;

const StyledLink = styled(Link)`
  color: red;
  background: blue;
`;

const H44 = styled.div`
  color: currentColor;
  font-size: 14px;
  font-weight: bolder;
  color: rgba(0, 36, 77, 1);
  ${props =>
    props.active &&
    css`
      color: #0073f7;
    `}
`;


export const PAlogo = ()=> {
  return (
    <svg
            width={184}
            height={72}
            viewBox="0 0 184 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0H72V72H0V0Z"
              fill="#0073F7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M46.3912 19.5869L48.5837 17.2216L46.9933 15.5259L44.8165 17.8894L44.8132 17.8833L43.2222 19.5809L43.2256 19.5869L43.2222 19.5905L46.0493 22.6285L43.8759 24.972L45.45 26.6865L49.2222 22.6212L46.3912 19.5869ZM52.2331 44.7151C49.6306 44.7151 47.5083 42.606 47.5083 39.9945C47.5083 37.3818 49.6306 35.2715 52.2331 35.2715C54.8165 35.2715 56.9369 37.3818 56.9369 39.9945C56.9369 42.606 54.8165 44.7151 52.2331 44.7151ZM52.2328 37.8471C51.0362 37.8471 50.0806 38.8235 50.0806 40.0024C50.0806 41.1802 51.0362 42.1396 52.2328 42.1396C53.4095 42.1396 54.3663 41.1802 54.3663 40.0024C54.3663 38.8235 53.4095 37.8471 52.2328 37.8471ZM32.9366 56.7342H35.508V48.1492H32.9366V56.7342ZM38.9373 56.7342H36.3659V48.1492H38.9373V56.7342ZM14.9375 43.8565L20.0889 35.2715L25.2232 43.8565H14.9375ZM20.1059 39.3352L21.5628 41.9576H18.6491L20.1059 39.3352ZM29.4958 16.3845L31.2224 18.1272L28.2418 21.0961L31.2224 24.0847L29.4958 25.8281L26.5072 22.8395L23.5198 25.8281L21.7938 24.0847L24.7837 21.0961L21.7938 18.1272L23.5198 16.3845L26.5072 19.3712L29.4958 16.3845Z"
              fill="white"
            />
            <path
              d="M88.594 25H91.45L88.202 19.694L91.184 14.962H88.342L86.69 17.748L85.038 14.962H82.224L85.15 19.694L81.888 25H84.842L86.718 21.836L88.594 25ZM95.1534 25.224C97.6734 25.224 98.9054 24.02 98.9054 22.396C98.9054 20.506 97.2254 20.156 95.8254 19.974C94.6214 19.82 93.9354 19.736 93.9354 19.232C93.9354 18.84 94.2154 18.546 94.9994 18.546C95.7694 18.546 96.1894 18.854 96.3014 19.414H98.8074C98.5554 17.79 97.4634 16.698 95.0274 16.698C92.7314 16.698 91.4854 17.804 91.4854 19.386C91.4854 21.318 93.1374 21.626 94.5374 21.808C95.5454 21.934 96.4274 22.004 96.4274 22.564C96.4274 23.012 96.0774 23.278 95.2794 23.278C94.4534 23.278 93.9494 22.97 93.7814 22.284H91.1494C91.4154 24.16 92.7314 25.224 95.1534 25.224ZM103.734 25.21C106.212 25.21 107.836 23.838 107.836 21.136V20.884C107.836 18.168 106.184 16.712 103.748 16.712C101.354 16.712 99.6459 18.126 99.6459 20.884V21.136C99.6459 23.838 101.102 25.21 103.734 25.21ZM103.748 23.012C102.81 23.012 102.18 22.354 102.18 21.108V20.884C102.18 19.526 102.81 18.868 103.762 18.868C104.742 18.868 105.302 19.554 105.302 20.884V21.108C105.302 22.382 104.686 23.012 103.748 23.012ZM111.499 25V14.22H108.923V25H111.499ZM115.491 25V14.22H112.915V25H115.491ZM120.087 23.348C119.471 23.348 119.149 23.11 119.149 22.634C119.149 22.354 119.261 22.158 119.485 21.99C119.737 21.822 120.003 21.752 120.703 21.626C121.193 21.528 121.557 21.43 121.795 21.248V21.738C121.795 22.536 121.109 23.348 120.087 23.348ZM122.187 25H124.287V19.82C124.287 17.944 123.321 16.712 120.633 16.712C118.099 16.712 116.811 17.958 116.685 19.848H119.275C119.303 19.092 119.737 18.672 120.633 18.672C121.501 18.672 121.781 18.994 121.781 19.456C121.781 19.974 121.277 20.114 120.045 20.282C118.729 20.492 118.141 20.604 117.497 21.01C116.839 21.416 116.433 22.046 116.433 23.026C116.433 24.37 117.287 25.21 119.051 25.21C120.563 25.21 121.445 24.552 121.907 23.642L122.187 25ZM86.676 35.118C87.684 35.118 88.23 35.622 88.23 36.476C88.23 37.4 87.642 37.862 86.69 37.862H85.262V35.118H86.676ZM86.76 40.032C89.518 40.046 90.792 38.674 90.792 36.476C90.792 34.348 89.504 32.962 86.718 32.962H82.742V43H85.262V40.032H86.76ZM97.1522 43H99.3082V34.88H96.7182V39.108C96.7182 40.2 96.3822 40.942 95.4862 40.942C94.5762 40.942 94.3522 40.284 94.3522 39.29V34.88H91.8042V40.046C91.8042 42.02 92.6862 43.154 94.4922 43.154C95.7102 43.154 96.5082 42.566 96.9142 41.628L97.1522 43ZM105.55 43.21C107.552 43.21 108.77 41.726 108.77 38.968V38.716C108.77 35.972 107.426 34.726 105.606 34.712C104.472 34.712 103.66 35.258 103.226 36.182V32.22H100.706V43H102.932L103.128 41.642C103.52 42.594 104.318 43.21 105.55 43.21ZM104.724 40.984C103.8 40.984 103.184 40.326 103.184 38.912V38.73C103.184 37.54 103.814 36.826 104.738 36.826C105.62 36.826 106.236 37.47 106.236 38.758V38.954C106.236 40.382 105.662 40.984 104.724 40.984ZM112.429 43V32.22H109.853V43H112.429ZM115.161 34.418C116.197 34.418 116.687 34.082 116.687 33.158C116.687 32.206 116.169 31.884 115.161 31.884C114.139 31.884 113.635 32.206 113.635 33.158C113.635 34.11 114.041 34.418 115.161 34.418ZM113.831 43H116.477V34.922C116.323 35.02 115.595 35.09 115.161 35.09C114.727 35.09 113.971 35.034 113.831 34.936V43ZM121.308 43.224C123.828 43.224 125.06 42.02 125.06 40.396C125.06 38.506 123.38 38.156 121.98 37.974C120.776 37.82 120.09 37.736 120.09 37.232C120.09 36.84 120.37 36.546 121.154 36.546C121.924 36.546 122.344 36.854 122.456 37.414H124.962C124.71 35.79 123.618 34.698 121.182 34.698C118.886 34.698 117.64 35.804 117.64 37.386C117.64 39.318 119.292 39.626 120.692 39.808C121.7 39.934 122.582 40.004 122.582 40.564C122.582 41.012 122.232 41.278 121.434 41.278C120.608 41.278 120.104 40.97 119.936 40.284H117.304C117.57 42.16 118.886 43.224 121.308 43.224ZM128.478 38.758C128.478 37.652 128.856 36.91 129.794 36.91C130.732 36.91 130.998 37.582 130.998 38.562V43H133.56V37.806C133.56 35.846 132.734 34.712 130.9 34.712C129.724 34.712 128.926 35.258 128.478 36.126V32.22H125.944V43H128.478V38.758ZM138.819 36.644C139.771 36.644 140.247 37.176 140.359 38.086H137.153C137.321 37.134 137.867 36.644 138.819 36.644ZM142.823 40.424H140.121C139.925 40.886 139.533 41.194 138.819 41.194C137.839 41.194 137.279 40.662 137.153 39.682H142.879V38.772C142.879 36.574 141.661 34.712 138.791 34.712C136.257 34.712 134.619 36.294 134.619 38.898V39.136C134.619 41.642 135.935 43.21 138.749 43.21C141.115 43.21 142.375 42.132 142.823 40.424ZM146.527 43V39.402C146.527 37.96 146.891 37.442 148.375 37.442H149.327V34.768H148.865C147.409 34.768 146.583 35.286 146.317 36.546L145.967 34.88H143.923V43H146.527ZM87.768 57.164H85.724L86.732 53.902L87.768 57.164ZM89 61H91.576L88.048 50.962H85.444L81.958 61H84.548L85.094 59.236H88.44L89 61ZM95.7632 61.21C98.1292 61.21 99.7532 60.118 99.8512 57.57V57.5H97.2052V57.528C97.1212 58.55 96.6172 59.012 95.7772 59.012C94.8532 59.012 94.2652 58.354 94.2652 57.108V56.884C94.2652 55.526 94.8532 54.868 95.7912 54.868C96.6312 54.868 97.1072 55.302 97.1912 56.296V56.352H99.8372V56.31C99.7392 53.832 98.1292 52.712 95.7772 52.712C93.3972 52.712 91.6752 54.126 91.6752 56.884V57.136C91.6752 59.838 93.1452 61.21 95.7632 61.21ZM104.718 61.21C107.084 61.21 108.708 60.118 108.806 57.57V57.5H106.16V57.528C106.076 58.55 105.572 59.012 104.732 59.012C103.808 59.012 103.22 58.354 103.22 57.108V56.884C103.22 55.526 103.808 54.868 104.746 54.868C105.586 54.868 106.062 55.302 106.146 56.296V56.352H108.792V56.31C108.694 53.832 107.084 52.712 104.732 52.712C102.352 52.712 100.63 54.126 100.63 56.884V57.136C100.63 59.838 102.1 61.21 104.718 61.21ZM113.673 61.21C116.151 61.21 117.775 59.838 117.775 57.136V56.884C117.775 54.168 116.123 52.712 113.687 52.712C111.293 52.712 109.585 54.126 109.585 56.884V57.136C109.585 59.838 111.041 61.21 113.673 61.21ZM113.687 59.012C112.749 59.012 112.119 58.354 112.119 57.108V56.884C112.119 55.526 112.749 54.868 113.701 54.868C114.681 54.868 115.241 55.554 115.241 56.884V57.108C115.241 58.382 114.625 59.012 113.687 59.012ZM124.168 61H126.324V52.88H123.734V57.108C123.734 58.2 123.398 58.942 122.502 58.942C121.592 58.942 121.368 58.284 121.368 57.29V52.88H118.82V58.046C118.82 60.02 119.702 61.154 121.508 61.154C122.726 61.154 123.524 60.566 123.93 59.628L124.168 61ZM130.311 56.758C130.311 55.638 130.675 54.91 131.641 54.91C132.579 54.91 132.831 55.554 132.831 56.562V61H135.407V55.834C135.407 53.874 134.455 52.712 132.649 52.712C131.389 52.712 130.549 53.314 130.129 54.252L129.891 52.88H127.721V61H130.311V56.758ZM141.746 58.634H141.228C140.024 58.634 139.814 58.48 139.814 57.08V55.134H141.746V52.88H139.814V50.85H137.714C137.7 51.186 137.672 51.62 137.63 51.956C137.546 52.642 137.35 52.866 136.832 52.936C136.552 52.992 136.342 53.02 136.034 53.02V55.134H137.406V57.584C137.406 60.118 138.008 61 140.458 61H141.746V58.634Z"
              fill="#FFF"
            />
          </svg>
  )
}

export const PAlogoBe = ()=> {
  return (
    <div style={{width: 170}}>
    <svg xmlns="http://www.w3.org/2000/svg" width={147} height={73} viewBox="0 0 147 73" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M0 0H72V72.1146H0V0Z" fill="#0073F7" />
  <path fillRule="evenodd" clipRule="evenodd" d="M47.6003 17.4466L50.0668 14.7856L48.2776 12.8779L45.8287 15.5369L45.825 15.5301L44.0351 17.4398L44.0389 17.4466L44.0351 17.4507L47.2156 20.8683L44.7705 23.5048L46.5414 25.4336L50.7851 20.8602L47.6003 17.4466ZM54.1723 45.7157C51.2445 45.7157 48.857 43.343 48.857 40.4051C48.857 37.4658 51.2445 35.0917 54.1723 35.0917C57.0786 35.0917 59.4641 37.4658 59.4641 40.4051C59.4641 43.343 57.0786 45.7157 54.1723 45.7157ZM54.1709 37.9897C52.8247 37.9897 51.7496 39.0882 51.7496 40.4145C51.7496 41.7395 52.8247 42.8188 54.1709 42.8188C55.4947 42.8188 56.5711 41.7395 56.5711 40.4145C56.5711 39.0882 55.4947 37.9897 54.1709 37.9897ZM32.4638 59.2375H35.3566V49.5793H32.4638V59.2375ZM39.2143 59.2375H36.3214V49.5793H39.2143V59.2375ZM12.2139 44.7499L18.0092 35.0917L23.7853 44.7499H12.2139ZM18.0287 39.6635L19.6677 42.6137H16.3897L18.0287 39.6635ZM28.593 13.844L30.5354 15.8046L27.1821 19.1446L30.5354 22.5068L28.593 24.468L25.2308 21.1059L21.8699 24.468L19.9282 22.5068L23.2918 19.1446L19.9282 15.8046L21.8699 13.844L25.2308 17.2041L28.593 13.844Z" fill="white" />
  <path d="M88.5942 24.9997H91.4502L88.2022 19.6937L91.1842 14.9617H88.3422L86.6902 17.7477L85.0382 14.9617H82.2242L85.1502 19.6937L81.8882 24.9997H84.8422L86.7182 21.8357L88.5942 24.9997Z" fill="white" />
  <path d="M95.1536 25.2237C97.6736 25.2237 98.9056 24.0197 98.9056 22.3957C98.9056 20.5057 97.2256 20.1557 95.8256 19.9737C94.6216 19.8197 93.9356 19.7357 93.9356 19.2317C93.9356 18.8397 94.2156 18.5457 94.9996 18.5457C95.7696 18.5457 96.1896 18.8537 96.3016 19.4137H98.8076C98.5556 17.7897 97.4636 16.6977 95.0276 16.6977C92.7316 16.6977 91.4856 17.8037 91.4856 19.3857C91.4856 21.3177 93.1376 21.6257 94.5376 21.8077C95.5456 21.9337 96.4276 22.0037 96.4276 22.5637C96.4276 23.0117 96.0776 23.2777 95.2796 23.2777C94.4536 23.2777 93.9496 22.9697 93.7816 22.2837H91.1496C91.4156 24.1597 92.7316 25.2237 95.1536 25.2237Z" fill="white" />
  <path d="M103.734 25.2097C106.212 25.2097 107.836 23.8377 107.836 21.1357V20.8837C107.836 18.1677 106.184 16.7117 103.748 16.7117C101.354 16.7117 99.6461 18.1257 99.6461 20.8837V21.1357C99.6461 23.8377 101.102 25.2097 103.734 25.2097ZM103.748 23.0117C102.81 23.0117 102.18 22.3537 102.18 21.1077V20.8837C102.18 19.5257 102.81 18.8677 103.762 18.8677C104.742 18.8677 105.302 19.5537 105.302 20.8837V21.1077C105.302 22.3817 104.686 23.0117 103.748 23.0117Z" fill="white" />
  <path d="M111.499 24.9997V14.2197H108.923V24.9997H111.499Z" fill="white" />
  <path d="M115.491 24.9997V14.2197H112.915V24.9997H115.491Z" fill="white" />
  <path d="M120.088 23.3477C119.472 23.3477 119.15 23.1097 119.15 22.6337C119.15 22.3537 119.262 22.1577 119.486 21.9897C119.738 21.8217 120.004 21.7517 120.704 21.6257C121.194 21.5277 121.558 21.4297 121.796 21.2477V21.7377C121.796 22.5357 121.11 23.3477 120.088 23.3477ZM122.188 24.9997H124.288V19.8197C124.288 17.9437 123.322 16.7117 120.634 16.7117C118.1 16.7117 116.812 17.9577 116.686 19.8477H119.276C119.304 19.0917 119.738 18.6717 120.634 18.6717C121.502 18.6717 121.782 18.9937 121.782 19.4557C121.782 19.9737 121.278 20.1137 120.046 20.2817C118.73 20.4917 118.142 20.6037 117.498 21.0097C116.84 21.4157 116.434 22.0457 116.434 23.0257C116.434 24.3697 117.288 25.2097 119.052 25.2097C120.564 25.2097 121.446 24.5517 121.908 23.6417L122.188 24.9997Z" fill="white" />
  <path d="M87.0402 42.9997C89.6162 42.9997 90.7782 41.9357 90.7782 40.0737C90.7782 38.8837 90.2462 38.1977 89.3222 37.8337C90.1202 37.4417 90.5542 36.7277 90.5542 35.5657C90.5542 33.8857 89.3642 32.9617 86.6342 32.9617H82.7422V42.9997H87.0402ZM86.7462 34.9777C87.6842 34.9777 88.0622 35.2717 88.0622 35.9017C88.0622 36.5737 87.6422 36.8817 86.7462 36.8817H85.2482V34.9777H86.7462ZM86.6202 38.8277C87.7682 38.8277 88.1882 39.1497 88.1882 39.8217C88.1882 40.4797 87.8242 40.8297 86.6062 40.8297H85.2482V38.8277H86.6202Z" fill="white" />
  <path d="M97.1113 42.9997H99.2673V34.8797H96.6773V39.1077C96.6773 40.1997 96.3413 40.9417 95.4453 40.9417C94.5353 40.9417 94.3113 40.2837 94.3113 39.2897V34.8797H91.7633V40.0457C91.7633 42.0197 92.6453 43.1537 94.4513 43.1537C95.6693 43.1537 96.4673 42.5657 96.8733 41.6277L97.1113 42.9997Z" fill="white" />
  <path d="M103.999 43.2237C106.519 43.2237 107.751 42.0197 107.751 40.3957C107.751 38.5057 106.071 38.1557 104.671 37.9737C103.467 37.8197 102.781 37.7357 102.781 37.2317C102.781 36.8397 103.061 36.5457 103.845 36.5457C104.615 36.5457 105.035 36.8537 105.147 37.4137H107.653C107.401 35.7897 106.309 34.6977 103.873 34.6977C101.577 34.6977 100.331 35.8037 100.331 37.3857C100.331 39.3177 101.983 39.6257 103.383 39.8077C104.391 39.9337 105.273 40.0037 105.273 40.5637C105.273 41.0117 104.923 41.2777 104.125 41.2777C103.299 41.2777 102.795 40.9697 102.627 40.2837H99.9953C100.261 42.1597 101.577 43.2237 103.999 43.2237Z" fill="white" />
  <path d="M110.034 34.4177C111.07 34.4177 111.56 34.0817 111.56 33.1577C111.56 32.2057 111.042 31.8837 110.034 31.8837C109.012 31.8837 108.508 32.2057 108.508 33.1577C108.508 34.1097 108.914 34.4177 110.034 34.4177ZM108.704 42.9997H111.35V34.9217C111.196 35.0197 110.468 35.0897 110.034 35.0897C109.6 35.0897 108.844 35.0337 108.704 34.9357V42.9997Z" fill="white" />
  <path d="M115.341 38.7577C115.341 37.6377 115.705 36.9097 116.671 36.9097C117.609 36.9097 117.861 37.5537 117.861 38.5617V42.9997H120.437V37.8337C120.437 35.8737 119.485 34.7117 117.679 34.7117C116.419 34.7117 115.579 35.3137 115.159 36.2517L114.921 34.8797H112.751V42.9997H115.341V38.7577Z" fill="white" />
  <path d="M125.694 36.6437C126.646 36.6437 127.122 37.1757 127.234 38.0857H124.028C124.196 37.1337 124.742 36.6437 125.694 36.6437ZM129.698 40.4237H126.996C126.8 40.8857 126.408 41.1937 125.694 41.1937C124.714 41.1937 124.154 40.6617 124.028 39.6817H129.754V38.7717C129.754 36.5737 128.536 34.7117 125.666 34.7117C123.132 34.7117 121.494 36.2937 121.494 38.8977V39.1357C121.494 41.6417 122.81 43.2097 125.624 43.2097C127.99 43.2097 129.25 42.1317 129.698 40.4237Z" fill="white" />
  <path d="M134.31 43.2237C136.83 43.2237 138.062 42.0197 138.062 40.3957C138.062 38.5057 136.382 38.1557 134.982 37.9737C133.778 37.8197 133.092 37.7357 133.092 37.2317C133.092 36.8397 133.372 36.5457 134.156 36.5457C134.926 36.5457 135.346 36.8537 135.458 37.4137H137.964C137.712 35.7897 136.62 34.6977 134.184 34.6977C131.888 34.6977 130.642 35.8037 130.642 37.3857C130.642 39.3177 132.294 39.6257 133.694 39.8077C134.702 39.9337 135.584 40.0037 135.584 40.5637C135.584 41.0117 135.234 41.2777 134.436 41.2777C133.61 41.2777 133.106 40.9697 132.938 40.2837H130.306C130.572 42.1597 131.888 43.2237 134.31 43.2237Z" fill="white" />
  <path d="M142.595 43.2237C145.115 43.2237 146.347 42.0197 146.347 40.3957C146.347 38.5057 144.667 38.1557 143.267 37.9737C142.063 37.8197 141.377 37.7357 141.377 37.2317C141.377 36.8397 141.657 36.5457 142.441 36.5457C143.211 36.5457 143.631 36.8537 143.743 37.4137H146.249C145.997 35.7897 144.905 34.6977 142.469 34.6977C140.173 34.6977 138.927 35.8037 138.927 37.3857C138.927 39.3177 140.579 39.6257 141.979 39.8077C142.987 39.9337 143.869 40.0037 143.869 40.5637C143.869 41.0117 143.519 41.2777 142.721 41.2777C141.895 41.2777 141.391 40.9697 141.223 40.2837H138.591C138.857 42.1597 140.173 43.2237 142.595 43.2237Z" fill="white" />
  <path d="M89.9382 58.7177H85.2482V57.0237H89.3502V54.8257H85.2482V53.1457H89.7982V50.9617H82.7422V60.9997H89.9382V58.7177Z" fill="white" />
  <path d="M93.6027 56.7577C93.6027 55.6377 93.9667 54.9097 94.9327 54.9097C95.8707 54.9097 96.1227 55.5537 96.1227 56.5617V60.9997H98.6987V55.8337C98.6987 53.8737 97.7467 52.7117 95.9407 52.7117C94.6807 52.7117 93.8407 53.3137 93.4207 54.2517L93.1827 52.8797H91.0127V60.9997H93.6027V56.7577Z" fill="white" />
  <path d="M103.412 64.4297C106.464 64.4297 107.794 63.3097 107.794 61.5317C107.794 60.0197 106.758 59.0957 104.49 59.0957H102.754C101.872 59.0957 101.62 58.9977 101.62 58.7177C101.62 58.4237 101.844 58.2837 103.076 58.2837H103.552C105.974 58.2837 107.374 57.3317 107.374 55.4977V55.4417C107.374 54.2097 106.618 53.3837 105.246 53.1037C106.996 53.1037 107.472 52.7817 107.472 51.4797V51.2417H104.728V51.5217C104.728 52.5297 104.616 52.7397 103.51 52.7817L103.3 52.7957C101.186 52.8657 99.8144 53.7477 99.8144 55.4697V55.4837C99.8144 56.6317 100.346 57.3457 101.354 57.7237C100.234 57.9757 99.6044 58.5777 99.6044 59.5297C99.6044 60.4117 100.178 60.9577 101.214 61.1257C100.01 61.3497 99.4644 61.8957 99.4644 62.6937C99.4644 63.7717 100.262 64.4297 103.3 64.4297H103.412ZM103.58 56.6037C102.838 56.6037 102.348 56.2817 102.348 55.5677V55.5117C102.348 54.7417 102.88 54.3917 103.594 54.3917C104.308 54.3917 104.826 54.6857 104.826 55.4977V55.5537C104.826 56.2677 104.35 56.6037 103.58 56.6037ZM103.272 62.6377C102.166 62.6377 101.774 62.3017 101.774 61.9377V61.9237C101.774 61.4897 102.278 61.2097 103.118 61.1817H104.364C105.302 61.1817 105.596 61.4197 105.596 61.7977C105.596 62.2877 105.036 62.6377 103.622 62.6377H103.272Z" fill="white" />
  <path d="M109.829 52.4177C110.865 52.4177 111.355 52.0817 111.355 51.1577C111.355 50.2057 110.837 49.8837 109.829 49.8837C108.807 49.8837 108.303 50.2057 108.303 51.1577C108.303 52.1097 108.709 52.4177 109.829 52.4177ZM108.499 60.9997H111.145V52.9217C110.991 53.0197 110.263 53.0897 109.829 53.0897C109.395 53.0897 108.639 53.0337 108.499 52.9357V60.9997Z" fill="white" />
  <path d="M115.136 56.7577C115.136 55.6377 115.5 54.9097 116.466 54.9097C117.404 54.9097 117.656 55.5537 117.656 56.5617V60.9997H120.232V55.8337C120.232 53.8737 119.28 52.7117 117.474 52.7117C116.214 52.7117 115.374 53.3137 114.954 54.2517L114.716 52.8797H112.546V60.9997H115.136V56.7577Z" fill="white" />
  <path d="M125.489 54.6437C126.441 54.6437 126.917 55.1757 127.029 56.0857H123.823C123.991 55.1337 124.537 54.6437 125.489 54.6437ZM129.493 58.4237H126.791C126.595 58.8857 126.203 59.1937 125.489 59.1937C124.509 59.1937 123.949 58.6617 123.823 57.6817H129.549V56.7717C129.549 54.5737 128.331 52.7117 125.461 52.7117C122.927 52.7117 121.289 54.2937 121.289 56.8977V57.1357C121.289 59.6417 122.605 61.2097 125.419 61.2097C127.785 61.2097 129.045 60.1317 129.493 58.4237Z" fill="white" />
</svg>
</div>
  )
}